import React, {isValidElement} from 'react';
import {Badge, Chip} from '@mui/material';
import {useContactUsUnreadCount} from './contact-us-unread-count-context';

/**
 * Unread count badge for Contact Us Messages sidebar entries.
 * Count state is owned by ContactUsUnreadCountProvider (no per-mount fetch).
 *
 * @param {{
 *   variant?: 'chip' | 'iconOverlay',
 *   children?: React.ReactNode,
 * }} props
 */
const ContactUsMessagesUnreadBadge = ({variant = 'chip', children = null}) => {
    const {unreadCount} = useContactUsUnreadCount();
    const label = unreadCount > 99 ? '99+' : String(unreadCount);

    if (variant === 'iconOverlay') {
        return (
            <Badge
                color="error"
                max={99}
                badgeContent={unreadCount}
                invisible={!unreadCount}
                overlap="circular"
                sx={{
                    '& .MuiBadge-badge': {
                        fontSize: '0.65rem',
                        minWidth: 16,
                        height: 16,
                        padding: '0 4px',
                    },
                }}
            >
                {isValidElement(children) || children != null ? children : <span/>}
            </Badge>
        );
    }

    if (!unreadCount) {
        return null;
    }

    return (
        <Chip
            size="small"
            color="error"
            label={label}
            sx={{
                height: 20,
                minWidth: 20,
                fontSize: '0.7rem',
                fontWeight: 600,
                '& .MuiChip-label': {
                    px: 0.75,
                },
            }}
        />
    );
};

export default ContactUsMessagesUnreadBadge;
